// LoadingPage.tsx
import styled, { keyframes } from 'styled-components';

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #6f7d8c;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  width: 60px;
  height: 60px;
`;

const pulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Square = styled.div<{ delay: number }>`
  width: 100%;
  height: 100%;
  background-color: white;
  animation: ${pulse} 1.5s ease-in-out infinite;
  animation-delay: ${props => props.delay}ms;
`;

const LoadingPage = () => {
  const squares = Array.from({ length: 9 }, (_, index) => {
    const delay = (index % 3 + Math.floor(index / 3)) * 100;
    return <Square key={index} delay={delay} />;
  });

  return (
    <Container>
      <GridContainer>
        {squares}
      </GridContainer>
    </Container>
  );
};

export default LoadingPage;